import React from 'react';
import NumberInput from 'src/modules/shared/components/atoms/inputs/number-input';
import { BaseFieldProps } from 'src/modules/shared/types/json-schema.type';

/**
 * Props for NumberField component
 */
export interface NumberFieldProps extends BaseFieldProps {
  fieldType?: 'number' | 'integer';
}

/**
 * Number field component for JSON Schema form
 * Handles both number and integer types with validation
 */
export const NumberField: React.FC<NumberFieldProps> = ({
  id,
  schema,
  value,
  onChange,
  disabled = false,
  nullable = false,
  fieldType = 'number',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const isEmpty = inputValue === '';

    if (isEmpty) {
      onChange(nullable ? null : undefined);
      return;
    }

    const parsed =
      fieldType === 'integer'
        ? parseInt(inputValue, 10)
        : Number.parseFloat(inputValue);

    if (Number.isNaN(parsed)) {
      onChange(undefined);
      return;
    }

    onChange(parsed);
  };

  // TODO: check when implementing i18n
  const placeholderText = nullable
    ? 'Ingresa un número o deja vacío para anular'
    : '';

  const valueToShow =
    value === null || value === undefined ? '' : (value as number | string);

  return (
    <NumberInput
      id={id}
      value={valueToShow}
      onChange={handleChange}
      placeholder={placeholderText}
      disabled={disabled}
      variant="primary"
      min={schema.minimum}
      max={schema.maximum}
      step={fieldType === 'integer' ? 1 : undefined}
    />
  );
};
